import { createContext } from "react";
import { MentionTextareaProps } from "@jugl-web/domain-resources/common/components/RichTextarea";
import CanvasLoader from "../CanvasLoader";
import { AvailableTool, ToolOptions } from "../tools/Tool";
import type { ToolbarActionName } from "./Toolbar/ToolbarAction";

export interface EditorContextValue {
  instance: CanvasLoader | null;
  setInstance: (loader: CanvasLoader | null) => void;
  activeTool: ToolbarActionName | null;
  setActiveTool: (toolName: ToolbarActionName, tool: AvailableTool) => void;
  toolOptions: ToolOptions | null;
  setToolOptions: (options: ToolOptions) => void;
  onEdit: ({ file, caption }: { file?: File; caption?: string }) => void;
  onSave: () => void;
  closeModal: () => void;
  caption: string;
  mentions?: MentionTextareaProps["mentions"];
}

export const EditorContext = createContext<EditorContextValue | undefined>(
  undefined
);
